const adminDivConfKeys = {
  all: ['ADMIN_DIV_CONF'],
  ymsYard: ({ div }) => [...adminDivConfKeys.all, 'YMS_YARD', div],
};

export default adminDivConfKeys;
